module.exports = __webpack_public_path__ + "static/6-883dd48f4d82643ee04ab80a4ab0b4d0.png";